import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Layout, Typography, Input, Button, Spin, Form, Breadcrumb } from 'antd';
import { fetchMasterCodes, createOrUpdateMasterCode } from '../../actions/MasterCodesActions';
import { DashboardOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import './MasterCodes.css';

const { Content } = Layout;
const { Title } = Typography;

const MasterCodes = () => {
    const dispatch = useDispatch();
    const { masterCodes, loading } = useSelector(state => state.masterCodes);

    const [editableFields, setEditableFields] = useState({
        staffCode: '',
    });

    useEffect(() => {
        window.scrollTo(0, 0);
        dispatch(fetchMasterCodes('registerCodes'));
    }, [dispatch]);

    useEffect(() => {
        if (masterCodes) {
            setEditableFields({
                staffCode: masterCodes.staffCode || '',
            });
        }
    }, [masterCodes]);

    const handleChange = (type, value) => {
        setEditableFields(prev => ({
            ...prev,
            [type]: value,
        }));
    };

    const handleSave = () => {
        dispatch(createOrUpdateMasterCode('registerCodes', editableFields));
    };

    return (
        <div style={{minHeight: "100vh"}} className="master-codes-container">
            {/* <Breadcrumb className="breadcrumb">
                <Breadcrumb.Item>
                    <Link to='/'>
                        <DashboardOutlined />
                    </Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>Admin Settings</Breadcrumb.Item>
                <Breadcrumb.Item>Master Codes</Breadcrumb.Item>
            </Breadcrumb> */}

            <Content className="master-codes-content">
                {loading ? (
                    <Spin size="large" />
                ) : (
                    <Form layout="vertical">
                        <Title level={4}>Register Codes</Title>
                        <Form.Item label="Staff Code">
                            <Input
                                value={editableFields.staffCode}
                                onChange={e => handleChange('staffCode', e.target.value)}
                                placeholder="Enter Staff Code"
                            />
                        </Form.Item>

                        <Button
                            type="primary"
                            onClick={handleSave}
                            disabled={!editableFields.staffCode || masterCodes.staffCode === editableFields.staffCode}
                            className="save-button"
                        >
                            Save Changes
                        </Button>
                    </Form>
                )}
            </Content>
        </div>
    );
};

export default MasterCodes;
